<template>
  <div class="dorm-form" :class="{ sticky : fixedForm }" :style="formOffset">

      <SubpageGallery
        gallery-class="mt-0"
        v-if="cityDetails && cityDetails.images.length > 0"
        :gallery="cityDetails.images"
        :img-count="cityDetails.images.length > 5 ? 5 : 3"
      />

          <!-- <transition name="enter">   --> 
 <Modal2 :active="showModal" @onModalClose="closeModal">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <span class="close" ref="close" v-on:click="closeModal">&times;</span>
    <v-button v-if="showErrorMessage"
      class="red fw shadow-none login-box__submit mycursor1"
      title="Please check your information!"
    />    
    <h3 class="login-box__title" >USER LOGIN</h3>
    <v-input ref="input1" placeholder="username" v-model="loginForm.email" />
    <!-- <label for="password" v-if="falseEmail" class="myValidationText" required>Wrong email format!</label> -->
    <label for="password" v-if="emptyEmail2" class="myValidationText">Can not be leave empty!</label> 
    <span class="text-danger"></span>
    <v-input ref="input2" placeholder="Password" type="password" v-model="loginForm.password" />
    <label for="password" v-if="emptyName" class="myValidationText" required>Can not be leave empty!</label> 
    <router-link class="password-forget" to="/sifremi-unuttum"> I Lost My Password</router-link>
    {{error}}
    <v-button
      class="green fw shadow-none login-box__submit"
      @click.native="login"
      title="LOGIN"/>
    <div class="or">
      <!-- <img src="@/assets/img/logo-colored.svg" alt="yurt holywoodskyline" class="preloader-svg" width="200">'da yeni misiniz? -->
      <p ><span class= "mycolorBlue1">Are you new at </span><span class="mycolor2a">HolywoodSkyline</span>.com?</p>
    </div>
    <v-button
      class="gray fw shadow-none login-box__submit"
      @click.native="register"
      title="REGISTER"
    />
    </div>
</div>
</Modal2>

 <Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >MESSAGE SENT!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Thanks You For Your Interest.</span></p>
      <p ><span class= "mycolorBlue">Our friends will be in contact with you soon.</span></p>
    </div>
     </div>
</div>
</Modal2>
  <div v-if="showRating">
    <star-rating v-model="rating" @click.native="rateMovie"></star-rating>
<!--     <div>Currently Selected: {{rating}}</div>
    <div><a href="#" @click.prevent="rating = 0">Reset Rating</a></div>
    <div><a href="#" @click.native="rateMovie">Reset Rating</a></div>  -->
  </div>
      <!-- </transition> -->
      <!-- Modal content -->
    <div class="dorm-form-buttons">
      <div class="dorm-form-buttons__left">
        <v-button
          class="dorm-form-buttons__item fw round"
          :class="[{
        'white blue': !isFavorite,
        'green white': isFavorite
      }]"
          icon="icon-heart"
          icon-position="left"
          :title="isFavorite ? 'Remove Favorites' : 'Add Favorites'"
          @click.native="setFavorite"
        />
      </div>

      <div class="dorm-form-buttons__right">
        <v-button
          class="dorm-form-buttons__item fw round"
          :class="[{
        'white blue': !isWatchlist,
        'green white': isWatchlist
      }]"
          icon="icon-bookmark"
          icon-position="left"
          :title="isWatchlist ? 'Remove Watchlist' : 'Add Watchlist'"
          @click.native="addToWatchlist"
        />
      </div>
    </div>
    
    <p>
      </p>
<div class="dorm-form-buttons">
          <div class="dorm-form-buttons__left">
        <v-button
          class="dorm-form-buttons__item fw round"
          :class="[{
          'white blue': !isShare,
          'green white': isShare
          }]"
          icon="icon-scoring"
          icon-position="left"
          title='Rate This Movie'
          @click.native="showRate"
        />
      </div>
      <div class="dorm-form-buttons__right">
        <v-button
          class="dorm-form-buttons__item fw round"
          :class="[{
          'white blue': !isShare,
          'green white': isShare
          }]"
          icon="icon-share"
          icon-position="left"
          title='Share'
          @click.native="showShare"
        />
      </div>      
    </div>
<!--  <social-sharing url="http://beta.holywoodskyline.com/celebrities"
                      title="About Movieu"
                      description="Hollywood movies."
                      quote="A Fine Movie !"
                      hashtags="holywoodskyline.com,"
                      twitter-user="User"
                      inline-template> -->
   <social-sharing v-if="showShareButtons" :url="this.url"
                      :title="this.name"
                      :description="this.description"
                      :quote="this.name"
                      hashtags="holywoodskyline"
                      :twitter-user="this.twitter_user"
                      inline-template> 
                      <div class="dorm-form__wrp mysharebuttons "> 
  <div class="icon-font">
      <network network="facebook">
      <span class="icon-font mybutton">
        <svg-icon type="icon-facebook" />
      </span>
      </network>
      <network network="twitter">     
      <span class="icon-font mybutton">
        <svg-icon type="icon-twitter" />
      </span>             
      </network>
      <network network="whatsapp">
      <span class="icon-font mybutton ">
        <svg-icon type="icon-whatsapp" />
      </span>       
      </network>

      <network network="email">
      <span class="icon-font mybutton">
        <svg-icon type="icon-mail" />
      </span>        
      </network>
<!--       <network network="googleplus">
        <i class="fa fa-google-plus"></i> Google +
      </network>
      <network network="line">
        <i class="fa fa-line"></i> Line
      </network>
      <network network="linkedin">
        <i class="fa fa-linkedin"></i> LinkedIn
      </network>
      <network network="odnoklassniki">
        <i class="fa fa-odnoklassniki"></i> Odnoklassniki
      </network>
      <network network="pinterest">
        <i class="fa fa-pinterest"></i> Pinterest
      </network>
      <network network="reddit">
        <i class="fa fa-reddit"></i> Reddit
      </network>
      <network network="skype">
        <i class="fa fa-skype"></i> Skype
      </network>
      <network network="sms">
        <i class="fa fa-commenting-o"></i> SMS
      </network>
      <network network="telegram">
        <i class="fa fa-telegram"></i> Telegram
      </network>
      <network network="vk">
        <i class="fa fa-vk"></i> VKontakte
      </network>
      <network network="weibo">
        <i class="fa fa-weibo"></i> Weibo
      </network>  -->

  </div>
  </div>
      
</social-sharing>
<div>&nbsp;</div>
    <!-- <SocialShare v-if="showShareButtons" /> -->
    <div class="dorm-form__wrp"
         :style="{ width: formWidth + 'px' }">
      <div v-show="!isMessage">
        <div class="dorm-form-tab">
<!--           <div class="dorm-form-tab__item"
               :class="{ active : tab.active }"
               v-for="(tab, $index) in tabs" :key="tab.id"
               @click="changePrice($index)"> -->
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>   
          <div class="dorm-form-tab__item mycolor mycursor1"
               :class="active"
               icon="icon-studio-red">
            <svg-icon type="icon-fiyat-sor" style="font-size:30; color:#eb6081;"/>   
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40">    -->
            <!-- <span class="dorm-form-tab__circle"></span>
            <div> -->
              <!-- <div class="dorm-form-tab__title">{{ tab.title }}</div> -->
              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <div class="dorm-form-tab__title">LEARN MOVIE PRICE</div>
              <!-- <div class="dorm-form-tab__txt">Rezervasyon Yap</div> -->
            </div>
          </div>
        </div>

        <div class="dorm-form__inner">

          <div class="dorm-form__form">
            <!-- <div v-if="!isMessage && showSuccessMessage"> -->
<!--             <div>
              <h2 class="color-blue font-300" v-if="showSuccessMessage">Mesajınız gönderildi.</h2>
              <h2 class="color-pink font-300" v-if="showErrorMessage">Mesajınız gönderilemedi!</h2>
            </div> -->
           <div>
             <div id="my-form" ref="myMessageForm" >
             <v-input ref="myInput"  placeholder="Fullname" v-model="user.name"/> 
            <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label> 
             <!-- <v-input  placeholder="Üniversite" v-model="messageForm.university" required/> -->
            <v-select v-if="user.university_name === 'Select Genre' || user.university_name === null || user.university_name ===''" :options="genres" placeholder="Select Genre" @onselect="selectUniversity"/>
             <VueSelectTempUniversity v-else :options="universities" placeholder="Select Genre" @onselect="selectUniversity"/>
             <label for="password" v-if="emptyUniversity" class="myValidationText">Can not be leave empty!</label> 
             <!-- <VueSelect2 v-if="messageForm.faculty_name === 'Fakülte Seç' && messageForm.university_name !='Üniversite Seç'" :options="faculties" placeholder='Fakülte Seç' :title="messageForm.faculty_name" @onselect="selectFaculty"/> -->
            <VueSelectTempFaculty placeholder="Select Studio" :options="studios"  @onselect="selectFaculty"/>
            <!-- <SelectBox2 v-else myplaceholder="Fakülte Seç" :options="faculties" :title="messageForm.faculty_name" @onselect="selectFaculty" disabled/> -->

            <label for="password" v-if="emptyFaculty" class="myValidationText">Can not be leave empty!</label> 
            <!-- <v-select placeholder="Genre Name" :options="universities" @onselect="selectUniversity"/> -->
            <!-- <v-select placeholder="Studio Name" :options="faculties" @onselect="selectFaculty"/> -->
            
             <!-- <v-input placeholder="Fakülte" v-model="messageForm.faculty"/> -->
             <VueInputRestricted  placeholder="Telephone" v-model="user.phone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Phone number must start with 0!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Phone number must be 11 digits!</label>
             <!-- <div :data-validation="emailValidation" data-validation-text="* Girilen e-mail geçersiz." > -->
             <v-input type="text" placeholder="E-Mail Address" v-model="user.email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Wrong email format!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label> 
             
            

             <!-- <input v-model="email" type="text" id="email" name="email" placeholder="E-mail buraya giriniz..."> -->
            <!--  </div> -->
             <!-- <v-input type="textarea" placeholder="Mesajınız" v-model="messageForm.message" required/>              -->
             <!--<v-select placeholder="Oda Tipi Seç" required :options="roomTypes"/>-->
             <!--<div class="dorm-form-price">-->
               <!--<div class="dorm-form-price__title">Ücret</div>-->
               <!--<div class="dorm-form-price__price" v-if="priceTypeMonth">-->
                 <!--{{ pricePerMonth }} TL <small>x aylık</small>-->
               <!--</div>-->
               <!--<div class="dorm-form-price__price" v-else>-->
                 <!--{{ pricePerDay }} TL <small>x günlük</small>-->
               <!--</div>-->
             <!--</div>-->

                       </div>
             <v-button
               class="red fw mt-15 dorm-form__submit"
               title="SEND"
               v-if="messageEnabled"
               @click.native="submitForm()"
             />
             <v-button
               class="red fw mt-15 dorm-form__submit"
               title="SENDING"
               v-if="!messageEnabled"
             />                                
           <!-- <button form='my-form' type="submit">Outside Button</button>             -->
           </div>

            <div class="or">
              <div class="or__title">OR</div>
            </div>

            <v-button
              v-show="!isNumberShow"
              class="gray icon-left fw dorm-form__button"
              icon="icon-headphone"
              icon-position="left"
              title="CALL CENTER"
              @click.native="showNumber"
            />
            
            <a v-if="isNumberShow" :href="'tel:' + phone1">
            <v-button
              v-show="isNumberShow"
              class="gray icon-left fw dorm-form__button"
              icon="icon-headphone"
              icon-position="left"
              :title="phone1"
            />
            </a>
<!-- 
            <form method="get" action="tel:212" v-show="isNumberShow"> 
            <v-button
              v-show="isNumberShow"
              class="gray icon-left fw dorm-form__button"
              icon-position="left"
              :title="phone"
            />
            </form> -->
            <!-- <a v-if="isNumberShow" class="button" href="tel:+phone">{{phone}}</a>  -->

            <v-button
              class="green icon-left fw dorm-form__button"
              icon="icon-whatsapp"
              icon-position="left"
              title="RENT MOVIE"
              @click.native="sendWhatsappMessage"
            />

          </div>
        </div>
<!--       <transition name="fade">
        <div class="dorm-form-message dorm-form__inner" v-if="isMessage">
          <div v-if="showSuccessMessage">
            <h2 class="color-blue font-600" v-if="!showErrorMessage">Mesajınız gönderildi.</h2>
            <h2 class="color-pink font-700" v-if="showErrorMessage">Mesajınız gönderilemedi!</h2>
          </div>
          <div v-else>
            <div class="color-pink font-700 font-size-18" v-if="showErrorMessage">{{ errorMessage }}</div>
            <v-input placeholder="Ad Soyad" :value="messageForm.name" @inputFocusOut="handleInput" required/>
            <v-input placeholder="Telefon No" v-model="messageForm.phone" @inputFocusOut="handleInput" required/>
            <v-input placeholder="E-Posta Adresi" v-model="messageForm.email" @inputFocusOut="handleInput" type="email" required/>
            <v-input placeholder="Mesajınız" v-model="messageForm.message" @inputFocusOut="handleInput" type="textarea" required/>
            <v-button
              class="gray icon-left fw dorm-form__button mt-15"
              icon="icon-mail"
              icon-position="left"
              title="MESAJ GÖNDER"
              @click.native="submitMessageForm"
            />
          </div>
        </div>
      </transition> -->
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import SocialSharing from 'vue-social-sharing'
import VueButton2 from '@/components/VueButton2'
import { SET_USER_INFO, SET_TOKEN } from '@/store/mutations.type'
import { mapGetters } from 'vuex'
import Modal2 from '@/components/Modal2'
import VueInputRestricted from '@/components/VueInputRestricted'
import SelectBox2 from '@/components/SelectBox2'
import VueSelectTempUniversity from '@/components/VueSelectTempUniversity1'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty1'
import VueSelect2 from '@/components/VueSelect2'
import {StarRating} from 'vue-rate-it';

//import SelectBoxTemp2 from '@/components/SelectBoxTemp2'
export default {
  
  name: 'DormForm',
  components: {
    StarRating, SocialSharing, VueButton2, Modal2, VueInputRestricted, SelectBox2,VueSelectTempUniversity, VueSelectTempFaculty, VueSelect2
  },
   metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.name + ' | ' + this.city_name + ' | ' + this.district_name,
       meta: [
         { vmid: 'description', name: 'description', content: this.description ? this.description : '' },
         { vmid: 'keywords', name: 'keywords', content: this.keywords ? this.keywords : '' }
       ],
       link: [
         { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.dorm_slug }
       ]      
    }
  },
  props: {
    fixedForm: Boolean,
    formOffset: Object,
    formWidth: Number,
    currentPrice: [String, Number],
    currentRoom: Object,
    dormId: Number,
    phone1: String,
    phoneForMessage: String,
    name: String,
    description: String,
    district_name: String,
    city_name: String,
    keywords: String,
    dorm_slug: String
  },
  data () {
    return {
      rating: 3,
      messageEnabled: true,
      facultyEnabled: false,
      page_url: '',
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      description1: null,
      name1: null,
     // first_name: null,
     // last_name: null,
      twitter_user: null,
      universities: null,
      faculties: null,      
      url: '',
      showModal: false,
      showRating: false,
      favorites: [],
      email: '',
      password: '',      
      showShareButtons: false,
      isFavorite: false,
      isWatchlist: false,
      isShare: false,
      isNumberShow: false,
      isMessage: false,
      hasError: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      errorMessageTemplate: 'Please fill all the sections in correct form.',
      errorMessage: 'Please fill all the sections in correct form.',
      user: {},
/*       messageForm: {
        dorm_id: '',
        name: '',
        email: '',
        university_id: '',
        faculty_id: '',
        phone: '',
        university_name: 'Üniversite Seç',
        faculty_name: 'Fakülte Seç'
      }, */
      loginForm: {
        email: null,
        password: null
      },
      reservationForm: {
        dorm_id: null,
        name: '',
        phone: '',
        room_type_id: 0
      },
      tabs: [
        {
          id: 0,
          title: 'DÖNEMLİK',
          active: true
        },
        {
          id: 1,
          title: 'DAILY',
          active: false
        }
      ],
      roomTypes: [
        {
          name: '2 Kişilik Lüks',
          value: 'two'
        },
        {
          name: '3 Kişilik Lüks',
          value: 'three'
        },
        {
          name: '4 Kişilik Normal',
          value: 'four'
        },
        {
          name: '5 Kişilik Fakir Odası',
          value: 'five'
        }
      ],
      pricePerDay: 90,
      pricePerMonth: 290,
      priceTypeMonth: true,
      genres: [
    {
      id: 28,
      name: "Action",
      slug: 'action'
    },
    {
      id: 12,
      name: "Adventure",
      slug:'adventure'
    },
    {
      id: 16,
      name: 'Animation',
      slug: 'animation'
    },
    {
      id: 35,
      name: "Comedy",
      slug:'comedy'
    },
    {
      id: 80,
      name: "Crime",
      slug: 'crime'
    },
    {
      id: 99,
      name: "Documentary",
      slug: 'documentary'
    },
    {
      id: 18,
      name: "Drama",
      slug: 'drama'
    },
    {
      id: 10751,
      name: "Family",
      slug: 'family'
    },
    {
      id: 14,
      name: "Fantasy",
      slug: 'fantasy'
    },
    {
      id: 36,
      name: "History",
      slug: 'history'
    },
    {
      id: 27,
      name: "Horror",
      slug: 'horror'
    },
    {
      id: 10402,
      name: "Music",
      slug: 'music'
    },
    {
      id: 9648,
      name: "Mystery",
      slug: 'mystery'
    },
    {
      id: 10749,
      name: "Romance",
      slug: 'romance'
    },
    {
      id: 878,
      name: "Science Fiction",
      slug:'science-fiction'
    },
    {
      id: 10770,
      name: "TV Movie",
      slug:'tv'
    },
    {
      id: 53,
      name: "Thriller",
      slug: 'thriller'
    },
    {
      id: 10752,
      name: "War",
      slug: 'war'
    },
    {
      id: 37,
      name: "Western",
      slug: 'western'
    }
      ],
studios: [
        {
  id: 1,
  name: 'Lucasfilm',
},
{
  id: 3,
  origin_country: "US",
},
{
  id: 4,
  name: "Paramount",
},
{
  id: 5,
  name: "Columbia Pictures",
},
{
  id: 6,
  name: "RKO Radio Pictures",
},
{
  id: 7,
  name: "DreamWorks Pictures",
},
{
  id: 8,
  name: "Fine Line Features",
},
{
    id: 9,
    name: "Gaumont",
},
{
  id: 10,
  name: "Highlight",
},
{
  id: 11,
  name: "WingNut Films",
},
{
  id: 12,
  name: "New Line Cinema",
},
{
  id: 14,
  name: "Miramax",
},
{
  id: 15,
  name: "Lama Films",
},
{
  id: 16,
  name: "United King Films",
},
{
  id: 18,
  name: "Gracie Films",
},

{
  id: 19,
  name: "Film Roman",
},
{
  id: 20,
  name: "Rough Draft Studios",
},
{
  id: 21,
  name: "Metro-Goldwyn-Mayer",
},
{
  id: 22,
  name: "Alejandro González Iñárritu",
},
{
  id: 23,
  name: "Imagine Entertainment",
},
{
  id: 24,
  name: "Mikona Productions GmbH & Co. KG",
},
{
  id: 25,
  name: "20th Century Fox",
},
{
  id: 26,
  logo_path: null,
  name: "Agustin Almodovar",
},
{
  id: 28,
  name: "Newmarket Films",
},
{
  id: 30,
  name: "Eddie Murphy Productions",
},
{
  id: 31,
  name: "Hamburger Filmschule",
},
{
  id: 32,
  name: "Buena Vista Pictures",
},
{
  id: 33,
  name: "Universal Pictures",
},
      ]      
    }
  },
  methods: {
    showRate() {
      this.showRating = !this.showRating
    },
    selectUniversity (opt) {
      this.user.university_id = opt.id
      this.user.university_name = opt.name
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    }, 
      getFaculties(id) {
        let self = this
        axios.get(`/selected/faculties/${id}`)
         .then(response => {
           self.faculties = response.data
         })
      },  
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
},  
    getUniversities () {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
      selectFaculty (opt) {
      this.user.faculty_id = opt.id
      this.user.faculty_name = opt.name
    },
    closeModal () {
      this.showModal = false
    },
    closeModal2 () {
      this.showSuccessMessage = false
    },    
    register () {
      this.$router.push('/uye-ol')
    },
    login () {
/*       if (this.validateForm()) {
                console.log('formValidated');
                //submit form to backend
            }

      this.validate()
      */
      this.falseEmail = false
      // this.falsePhone = false
      // this.shortPhone = false
      this.emptyName = false
      this.emptyEmail2 = false
      const verifiedMail = this.validateEmail(this.loginForm.email)
      if(!this.loginForm.password) {
      this.emptyName = true
      }
      if(!this.loginForm.email) {
        this.emptyEmail2 = true
      } else if(!this.emptyEmail2 && !verifiedMail) {
        this.falseEmail = true
      }

      if(!this.emptyName && verifiedMail && !this.falseEmail)  {
      var self = this
/*       if(!this.valid) {
        // this.email = 'Mail giriniz'
        this.$refs.input1.value = 'Mail giriniz'
      } */
      // if(this.valid) {
        axios.post(`/user/login`, {
          email: this.loginForm.email,
          password: this.loginForm.password
        })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              // self.showSuccessMessage = true
              self.$store.commit(SET_USER_INFO, response.data.user)
              const data = { updateLogin: true, isLogin: 'true' }
            //  self.$store.commit(SET_USER_INFO, data )
              self.$store.commit(SET_TOKEN, response.data.token )
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token
              this.closeModal()
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail1', response.data.user.email)
              window.localStorage.setItem('username1', response.data.user.first_name + ' ' + response.data.user.last_name)
              window.localStorage.setItem('first_name1', response.data.user.first_name)
              window.localStorage.setItem('last_name1', response.data.user.last_name)              
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              window.localStorage.setItem('type_id', response.data.user.type_id)
              if (response.data.user.university_id) {
                window.localStorage.setItem('university_id1', response.data.user.university_id)
              } else {
                window.localStorage.setItem('university_id1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem('faculty_id1', response.data.user.faculty_id)
              } else {
                window.localStorage.setItem('faculty_id1', '')
              }

              if (response.data.user.university_name) {
                window.localStorage.setItem('university_name1', response.data.user.university_name)
              } else {
                window.localStorage.setItem('university_name1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem('faculty_name1', response.data.user.faculty_name)
              } else {
                window.localStorage.setItem('faculty_name1', '')
              }
              self.user = response.data.user
              self.isFavorite = true
              axios.post(`/site/dorm/favorite/${self.dormId}`, {
              })

             // self.$router.push(self.$route.params.slug + '-y-' + self.dormId)            
// refresh yapmadan bilglieri formda güncellemiyor, sebebi anlaışamadı
window.open(window.location.origin + '/' + self.$route.params.slug + '-y-' + self.dormId, '_self')

// document.cookie = "username=response.data.user.first_name; expires=Thu, 18 Dec 2019 12:00:00 UTC";
            } else {
              self.showErrorMessage = true
            }
          })
        .catch(error => {
          if (error.response) {
            this.showErrorMessage = true
        }})          
      }    
    },
    sendWhatsappMessage () {
        axios.post(`site/dorm/view_number_button/${this.dormId}`, {
          type: 'whatsapp'
        })           // this.isMessage = true
      window.open('https://wa.me/' + this.phoneForMessage + '?text=Hello,%20Size%20holywoodskyline.com%20arac%C4%B1l%C4%B1%C4%9F%C4%B1yla%20ula%C5%9F%C4%B1yorum.%20Yurdunuz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum', '_blank')
    },
    showShare () {
      this.isShare = !this.isShare
      this.showShareButtons = !this.showShareButtons
    },
    setFavorite () {
      const session_id = window.localStorage.getItem('session_id')
      const isLogin = window.localStorage.getItem('isLogin')
      const id = window.localStorage.getItem('id')
      if(isLogin === '') {
        this.showModal = true
      // var modal = this.$refs.myModal 
      // modal.style.display = "block"
      } else {
      if (!this.isFavorite) {
        axios.post(`/3/account/{account_id}/favorite?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}`, {
            media_type: "movie",
            media_id: id,
            favorite: true
        })    
      } else {
        axios.post(`/3/account/{account_id}/favorite?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}`, {
            media_type: "movie",
            media_id: id,
            favorite: false

        })
      }
      this.isFavorite = !this.isFavorite
      }
    },
    rateMovie(rate) {
      this.showRating = false
      const session_id = window.localStorage.getItem('session_id')
      const isLogin = window.localStorage.getItem('isLogin')
      const id = window.localStorage.getItem('id')      
        axios.post(`/3/movie/${id}/rating?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}`, {
            value: this.rating,
        })
    },
    addToWatchlist () {
      const session_id = window.localStorage.getItem('session_id')
      const isLogin = window.localStorage.getItem('isLogin')
      const id = window.localStorage.getItem('id')
      if(isLogin === '') {
        this.showModal = true
      // var modal = this.$refs.myModal 
      // modal.style.display = "block"
      } else {
      if (!this.isWatchlist) {
        axios.post(`/3/account/{account_id}/watchlist?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}`, {
            media_type: "movie",
            media_id: id,
            watchlist: true
        })    
      } else {
        axios.post(`/3/account/{account_id}/watchlist?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}`, {
            media_type: "movie",
            media_id: id,
            watchlist: false

        })
      }
      this.isWatchlist = !this.isWatchlist
      }
    },    
    changePrice (index) {
      this.tabs.forEach((item) => {
        item.active = false
      })
      this.tabs[index].active = true
      this.priceTypeMonth = !this.priceTypeMonth
    },
    handleInput (value, status) {
      if (status === 'error') {
        this.hasError = true
      }
    },
    showNumber () {
      this.isNumberShow = true
        axios.post(`site/dorm/view_number_button/${this.dormId}`, {
          type: 'normal'
        })        
    },
    setOffsets () {
      this.formWidth = this.$refs.dormForm.offsetWidth
    },
    handleScroll () {
      let windowY = window.scrollY
      let contentOffsetTop = this.$refs.dormContent.offsetTop
      let contentOffsetLeft = this.$refs.dormContent.offsetLeft + this.$refs.dormRight.offsetLeft

      if (windowY >= contentOffsetTop) {
        this.fixedForm = true
        this.formOffset.left = contentOffsetLeft + 'px'
        this.formOffset.top = 10 + 'px'
      } else {
        this.fixedForm = false
        this.formOffset.left = 0
        this.formOffset.top = 23 + 'px'
      }
    },
    submitForm () {
  //    this.$refs.myinput.focus()
/*       var tmpSubmit = document.createElement('button')
    this.$refs.myMessageform.appendChild(tmpSubmit)
    tmpSubmit.click()
    this.$refs.myMessageform.removeChild(tmpSubmit)
 */
      // this.$refs.myMessageform.reportValidity()
      // this.$refs.myInput.checkValidity()
      
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      const verifiedMail = this.validateEmail(this.user.email)
      var self = this
      /*
               if(this.isLogin === '') {
                this.universities.forEach((data) => { 
            if(data.id == self.messageForm.university_id) {
                // self.university_name = data.name
                window.localStorage.setItem('university_name', data.name)
            }
            })
            if(this.messageForm.faculty_id && this.faculties) {
                this.faculties.forEach((data) => { 
            if(data.id == self.messageForm.faculty_id) {
                // self.university_name = data.name
                window.localStorage.setItem('faculty_name', data.name)
            }
            })
}
                window.localStorage.setItem('name', this.messageForm.name)
                window.localStorage.setItem('mail', this.messageForm.email)
                window.localStorage.setItem('phone1', this.messageForm.phone)
                window.localStorage.setItem('university_id', this.messageForm.university_id)
                window.localStorage.setItem('faculty_id', this.messageForm.faculty_id)
                
              }    
*/
      if(!this.user.email) {
        this.emptyEmail = true
      } else if(this.user.email &&!verifiedMail) {
        this.falseEmail = true
      }
      if(!this.user.name) {
        this.emptyName = true
      }
      if(!this.user.phone) {
        this.emptyPhone = true
      }

      if(this.user.phone && !this.user.phone.startsWith("0")) {
        this.falsePhone = true
      }      

      if(this.user.phone && !this.falsePhone && this.user.phone.length != 11) {
        this.shortPhone = true
      }

      if(!this.user.university_name || this.user.university_name == 'null') {
        this.emptyUniversity = true
      }

      if(!this.user.faculty_name || this.user.faculty_name == 'null') {
        this.emptyFaculty = true
      }      

if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity && !this.emptyFaculty) {
      // if (this.messageForm.name && verifiedMail && this.messageForm.phone && this.messageForm.university_id) {
      this.user.dorm_id = this.$route.params.id
   //   if (this.user.name === '' || this.user.phone === '' ||
    //    this.user.university_id === '1') {
        // this.showErrorMessage = true // for testing uncomment this line and block comment axios-then-catch
       // this.errorMessage= this.errorMessageTemplate
   //   } else {
        this.showErrorMessage = false
        let self = this
        const dorm_id = this.dormId // window.localStorage.getItem('dormid')
        this.messageEnabled = false
         axios.post(`/site/dorm/message/${dorm_id}`, {
          //data: this.messageForm
          name: this.user.name,
          email: this.user.email,
          phone: this.user.phone,
          university_id: this.user.university_id,
          faculty_id: this.user.faculty_id,
          dorm_id: this.user.dorm_id
        })
          .then(response => {
            this.messageEnabled = true
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
            }
          })
        .catch(error => {
          if (error.response) {
            this.showErrorMessage = true
        }})  
             this.showSuccessMessage = true
   //   }
      }
    },
    submitReservationForm () {
      this.reservationForm.dorm_id = this.$route.params.id
      if (this.reservationForm.name === '' || this.reservationForm.phone === '' ||
        this.reservationForm.room_type_id === '') {
        this.showErrorMessage = true
        this.errorMessage = this.errorMessageTemplate
      } else {
        this.showErrorMessage = false
        let self = this
        const dormd_id = window.localStorage.getItem('dormid')
        axios.post(`/site/dorm/reservation/${dorm_id}`, {
          data: this.reservationForm
        })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
            }
          })
      }
    },
    getFavorites () {
      let self = this
      // axios.get(`/user/favorites`)
      const session_id = window.localStorage.getItem('session_id')
      axios.get(`/3/account/{account_id}/favorite/movies?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}&language=en-US&sort_by=created_at.asc&page=1`)
        .then(response => {
          self.favorites = response.data.results
           let isFavorite  = self.favorites.find(function (dorm) { return dorm.id == window.localStorage.getItem('id') } )
           let dene = this.dormId
          if (isFavorite) {
            this.isFavorite = true
           }          
        })
        .catch(e => {
          self.errors.push(e)
        })

      // console.log('1 favori: ' + self.favorites[0]. location)
    },
    getFormData () {
            this.falseEmail = false
            this.falsePhone = false
            this.shortPhone = false
            this.emptyName = false
            this.emptyPhone = false
            this.emptyEmail = false
            this.emptyUniversity = false
            this.emptyFaculty = false

    // repopulate faculty dropdown
        if (!window.localStorage.getItem('university_id') || window.localStorage.getItem('university_id') === '' || window.localStorage.getItem('university_id') === 'null' || window.localStorage.getItem('university_id') === 'undefined') {
        } else {
              this.user.university_id = window.localStorage.getItem('university_id')
              this.getFaculties(window.localStorage.getItem('university_id'))
        }
/* if(!this.university_name) {


    if (!window.localStorage.getItem('university_name') || window.localStorage.getItem('university_name') === '' || window.localStorage.getItem('university_name') === 'null' || window.localStorage.getItem('university_name') === 'undefined') {
   // if(this.messageForm.university_id) {
      this.facultyEnabled = false
      this.university_name = ''
    } 
    else {
      this.messageForm.university_name = window.localStorage.getItem('university_name')
          this.messageForm.faculty_id = window.localStorage.getItem('faculty_id')
    this.messageForm.faculty_name = window.localStorage.getItem('faculty_name')
      this.facultyEnabled = true
       let self = this
     }
} */

/*       axios.get(`/selected/faculties/${this.messageForm.university_id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })  */      


 /*   
this.user.name = this.first_name + ' ' + this.last_name
this.user.email = this.mail1
this.user.phone = this.phone
this.user.university_name = this.university_name
this.user.faculty_name = this.faculty_name
*/
this.user.university_id= window.localStorage.getItem('university_id1')
this.user.faculty_id= window.localStorage.getItem('faculty_id1')

//window.localStorage.setItem('university_name', this.university_name)
//window.localStorage.setItem('university_id', )
//window.localStorage.setItem('faculty_name', this.faculty_name)
//window.localStorage.setItem('faculty_id', ' ')  

    // this.$refs.myMessageform.onsubmit = validateForm
    this.dormId = window.localStorage.getItem('dormid')
    this.url = 'https://holywoodskyline.com/' + window.localStorage.getItem('slug') 
    
/*     if(window.localStorage.getItem('username') == 'null') {
        this.messageForm.name = ''
    } else {
           this.messageForm.name = window.localStorage.getItem('username') 
    } 

     if (!window.localStorage.getItem('mail') || window.localStorage.getItem('mail') === '' || window.localStorage.getItem('mail') === 'null') {
        this.messageForm.email = ''
    } else {
           this.messageForm.email = window.localStorage.getItem('mail') 
    }

    
    if(window.localStorage.getItem('phone1') == 'null') {
        this.messageForm.phone = ''
    } else {
          this.messageForm.phone = window.localStorage.getItem('phone1') 
    } 

   
    if(!this.messageForm.university_name) {
        this.messageForm.university_name = 'Üniversite Seç'
    }   

    if(!this.messageForm.faculty_name) {
        this.messageForm.faculty_name = 'Fakülte Seç'
    }  
    */
   // this.last_name = window.localStorage.getItem('last_name')
    this.twitter_user = this.first_user + this.last_user      
    }  
  },
  mounted() {
   // this.selectUniversity({id:4, name: 'Kocaeli Üniversitesi'})
    //this.getFormData()
    // url = 'http://beta.holywoodskyline.com/url' + url
    if(this.isLogin) {
      this.getFavorites()
    }



  },
    computed: {
    ...mapGetters(['isLogin', 'first_name', 'last_name', 'mail1', 'phone','university_name','faculty_name', 'university_id','faculty_id'])
    },
  created () {
   // this.selectUniversity({id:4, name: 'Kocaeli Üniversitesi'})
  //  this.getUniversities()
    //this.getFormData()
  this.getFavorites()
  this.page_url = window.location.origin + '/' + window.localStorage.getItem('url')
  this.user.name = this.first_name + ' ' + this.last_name
  this.user.email = this.mail1
  this.user.phone = this.phone
  this.user.university_name = this.university_name
  this.user.faculty_name = this.faculty_name
  this.user.university_id= window.localStorage.getItem('university_id1')
  this.user.faculty_id= window.localStorage.getItem('faculty_id1')

  var self = this
    if(this.university_id !='') {
      axios.get(`/selected/faculties/${this.university_id}`)
        .then(response => {
          self.faculties = response.data
        })          
  }  
  }    
}
</script>

<style lang="scss">
@import "../../assets/scss/components/dorm-form";
.myColor {
background-color: #ec689e;
    color: red;
    font-size: 36;
}

modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  height: 45%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

  .mycolorBlue {
    color:#4b5ba4;
    font-weight: bold;
  }
  .mycolorBlue1 {
    color:#4b5ba4;
    font-weight: bold;
  }  
    .mycolor2a {
    color:#17d9ae;
    font-weight: bold;
  }

.mybutton {
    display: inline-block !important;
    padding: 10px 0;
}

.myborder {
      border-left: 1px solid #ddd;
      height: 30px;
      padding-left:3px;
}

.mysharebuttons {
    cursor: pointer;
    margin-top: 18px;
  }

  .mysharebuttons > .icon-font{
    font-size: 18px;
    color: #9198b2;
    width: 100%;
  }

  .mysharebuttons .icon-font > span{
    width: 33%;
    display: block;
    text-align: center;
    border-right: 1px solid #ddd;
      &:hover {
        .mybutton{
          color: #eb6081;
        }
      }
  }

  .mysharebuttons .icon-font > span:last-child{
    border-right: none;
  }

  .mycolorshare {
    color: #4b5ba4;
  }
  .mycursor1 { 
    cursor: default; }
  .mycursorPointer { 
    cursor: pointer; }
  .myValidationText {
    font-size: 13px;
    color: #dc3545;
  }
</style>
